import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "حاسبة شكل الوجه";
const DESCRIPTION = "حاسبة لتحديد شكل الوجه بناءً على القياسات والملامح.";
const KEYWORDS = "شكل الوجه, حاسبة, جمال, ملامح الوجه";
const OG_URL = "https://do-calculate.com/calculator/ar/face-shape-calculator/";
function Example() {
  const [sex, setSex] = useState("");
  const [foreheadWidth, setForeheadWidth] = useState();
  const [cheeksWidth, setCheeksWidth] = useState();
  const [jawlineLength, setJawlineLength] = useState();
  const [faceLength, setFaceLength] = useState();
  const [features, setFeatures] = useState("");
  const [result, setResult] = useState();
  const [error, setError] = useState("");
  const handleCalculate = () => {
    const minForeheadWidth = 7.62;
    const minCheeksWidth = 7.62;
    const minJawlineLength = 7.62;
    const minFaceLength = 12.7;
    if (
      foreheadWidth < minForeheadWidth ||
      cheeksWidth < minCheeksWidth ||
      jawlineLength < minJawlineLength ||
      faceLength < minFaceLength
    ) {
      setError(
        `القيم المدخلة غير صحيحة. يرجى التأكد من اتباع الحدود الدنيا للقياسات والتي هي:\n
            1- العرض الأقل للجبهة: ${minForeheadWidth} سم\n
            2- العرض الأقل للخدين: ${minCheeksWidth} سم\n
            3- الطول الأقل للفك: ${minJawlineLength} سم\n
            4- الطول الأقل للوجه: ${minFaceLength} سم`
      );
      return;
    }
    let faceShape = "غير محدد";
    if (faceLength > cheeksWidth && foreheadWidth > jawlineLength) {
      faceShape = "شكل الوجه: البيضاوي";
    } else if (faceLength > cheeksWidth && jawlineLength === foreheadWidth) {
      faceShape = "شكل الوجه: المستطيل";
    } else if (
      faceLength === cheeksWidth &&
      foreheadWidth < cheeksWidth &&
      jawlineLength < cheeksWidth
    ) {
      faceShape = "شكل الوجه: الدائري";
    } else if (
      faceLength === cheeksWidth &&
      jawlineLength > cheeksWidth &&
      jawlineLength === foreheadWidth
    ) {
      faceShape = "شكل الوجه: المربع";
    } else if (jawlineLength > cheeksWidth && cheeksWidth > foreheadWidth) {
      faceShape = "شكل الوجه: المثلث";
    } else if (jawlineLength < cheeksWidth && foreheadWidth >= cheeksWidth) {
      faceShape = "شكل الوجه: القلبي";
    } else if (
      jawlineLength < cheeksWidth &&
      foreheadWidth < cheeksWidth &&
      faceLength > foreheadWidth &&
      features === "حاد"
    ) {
      faceShape = "شكل الوجه: ألماسي";
    } else if (
      foreheadWidth === cheeksWidth &&
      faceLength === jawlineLength &&
      features === "حاد"
    ) {
      faceShape = "شكل الوجه: المربع";
    } else if (
      ((foreheadWidth === cheeksWidth) === faceLength) === jawlineLength &&
      (features === "مستدير" || "متوسط")
    ) {
      faceShape = "شكل الوجه: المستطيل";
    } else if (
      foreheadWidth === cheeksWidth &&
      faceLength === jawlineLength &&
      (features === "مستدير" || "متوسط")
    ) {
      faceShape = "شكل الوجه: المثلث";
    } else if (
      ((foreheadWidth === cheeksWidth) === faceLength) === jawlineLength &&
      features === "حاد"
    ) {
      faceShape = "شكل الوجه: المربع";
    }
    setResult(faceShape);
    setError("");
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  هل تساءلت يومًا عن شكل وجهك؟ هل هو بيضاوي، مربع، قلب، أم شكل
                  آخر؟ الآن، يمكنك معرفة ذلك بدقة باستخدام حاسبتنا الذكية لتحديد
                  شكل الوجه. ببساطة، قم بإدخال قياسات وجهك الأساسية واختيار وصف
                  لملامحك، وستحصل على نتيجة دقيقة في ثوانٍ.
                </p>
                <p>
                  تقوم حاسبتنا بتحليل البيانات التي تدخلها، مثل عرض الجبهة وعرض
                  الخدين وطول الفك وطول الوجه، بالإضافة إلى وصف لملامحك (حادة،
                  مستديرة، أو متوسطة الحدة). من خلال هذه المعلومات، تستطيع
                  الحاسبة تحديد الشكل الهندسي الذي يقترب من شكل وجهك. سواء كنت
                  مهتمًا بمعرفة شكل وجهك لمجرد الفضول، أو لتحديد قصات الشعر أو
                  النظارات المناسبة، فإن حاسبتنا هي الأداة المثالية لك.
                </p>
                <p>
                  لتحديد شكل الوجه، يمكنك إدخال القياسات المطلوبة واختيار وصف
                  الملامح.
                </p>
                <ul>
                  <li>
                    أدخل الجنس، عرض الجبهة، عرض الخدين، طول الفك، طول الوجه.
                  </li>
                  <li>اختر وحدة القياس (سم أو إنش).</li>
                  <li>
                    اختر كيف تصف ملامح وجهك: حادة، مستديرة، أو متوسطة الحدة.
                  </li>
                </ul>
                <p>
                  تم تطوير هذه الحاسبة بالاعتماد على دراسات تحليل شكل الوجه.
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div dir="rtl">
                  <div>
                    <hr />
                    <div className="form-group items-center">
                      <label className="form-label ms-2" htmlFor="sex">
                        اختر الجنس
                      </label>
                      <select
                        id="sex"
                        value={sex}
                        onChange={(e) => setSex(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      >
                        <option value="">اختر الجنس</option>
                        <option value="ذكر">ذكر</option>
                        <option value="أنثى">أنثى</option>
                      </select>
                    </div>
                    <div
                      className="form-group"
                      style={{ display: "flex", flexDirection: "column" }}
                    >
                      <label
                        
                        style={{ marginBottom: "0.5rem" }}
                        htmlFor="foreheadWidth"
                      >
                        عرض الجبهة
                      </label>
                      <div
                        className="d-flex"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <input
                          id="foreheadWidth"
                          type="number"
                          value={foreheadWidth}
                          onChange={(e) => setForeheadWidth(e.target.value)}
                          placeholder="أدخل عرض الجبهة"
                          className="form-control"
                          style={{ width: "75%" }}
                        />
                        <span className="input-group-text">سم</span>
                      </div>
                    </div>
                    <div
                      className="form-group"
                      style={{ display: "flex", flexDirection: "column" }}
                    >
                      <label
                        
                        style={{ marginBottom: "0.5rem" }}
                        htmlFor="cheeksWidth"
                      >
                        عرض الخدين
                      </label>
                      <div
                        className="d-flex"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <input
                          id="cheeksWidth"
                          type="number"
                          value={cheeksWidth}
                          onChange={(e) => setCheeksWidth(e.target.value)}
                          placeholder="أدخل عرض الخدين"
                          className="form-control"
                          style={{ width: "75%" }}
                        />
                        <span className="input-group-text">سم</span>
                      </div>
                    </div>
                    <div
                      className="form-group"
                      style={{ display: "flex", flexDirection: "column" }}
                    >
                      <label
                        
                        style={{ marginBottom: "0.5rem" }}
                        htmlFor="jawlineLength"
                      >
                        طول الفك
                      </label>
                      <div
                        className="d-flex"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <input
                          id="jawlineLength"
                          type="number"
                          value={jawlineLength}
                          onChange={(e) => setJawlineLength(e.target.value)}
                          placeholder="أدخل طول الفك"
                          className="form-control"
                          style={{ width: "75%" }}
                        />
                        <span className="input-group-text">سم</span>
                      </div>
                    </div>
                    <div
                      className="form-group"
                      style={{ display: "flex", flexDirection: "column" }}
                    >
                      <label
                        
                        htmlFor="faceLength"
                        style={{ marginBottom: "0.5rem" }}
                      >
                        طول الوجه
                      </label>
                      <div
                        className="d-flex"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <input
                          id="faceLength"
                          type="number"
                          value={faceLength}
                          onChange={(e) => setFaceLength(e.target.value)}
                          placeholder="أدخل طول الوجه"
                          className="form-control"
                          style={{ width: "75%" }}
                        />
                        <span className="input-group-text">سم</span>
                      </div>
                    </div>
                    <div className="form-group" >
                      <label className="form-label ms-2" htmlFor="features">صف ملامح وجهك</label>
                      <select
                        id="features"
                        value={features}
                        onChange={(e) => setFeatures(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      >
                        <option value="">اختر وصف الملامح</option>
                        <option value="حاد">حاد</option>
                        <option value="مستدير">مستدير</option>
                        <option value="متوسط">متوسط</option>
                      </select>
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={handleCalculate}
                    >
                      احسب                    </button>
                  </div>
                  <br />
                  { error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      خطأ: {error}
                    </p>
                  )}
                  {result &&  (
                    <div className="p-3 mb-2 bg-success text-white">
                      <h4>النتيجة:</h4>
                      <p className="text-white">{result}</p>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">المزيد عن أشكال الوجه</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>ما هي أشكال الوجه؟</h2>{" "}
                  </u>
                  <p>
                    يمكن تصنيف شكل الوجه بناءً على عدد من المعايير مثل عرض
                    الجبهة، عرض الخدين، طول الفك، وطول الوجه. كل هذه العوامل مع
                    وصف الملامح يمكن أن تساعد في تحديد شكل الوجه.
                  </p>
                  <div className="p-3 mb-2 bg-info ">
                    مثال: إذا كان عرض الجبهة أكبر من عرض الخدين وكان طول الوجه
                    أكبر من طول الفك، مع ملامح حادة، قد يكون شكل الوجه بيضاوي.
                  </div>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      كيف يمكن تحسين مظهر الوجه بناءً على الشكل؟
                    </h2>{" "}
                  </u>
                  <p>
                    يتيح لك معرفة شكل وجهك اختيار قصات الشعر، والنظارات،
                    والمكياج الذي يناسب ملامحك بشكل أفضل.
                  </p>
                  <ul>
                    <li>
                      شكل الوجه البيضاوي يناسبه تقريبًا أي نوع من قصات الشعر.
                    </li>
                    <li>
                      الشكل المربع قد يستفيد من قصات الشعر التي تضيف نعومة
                      للزوايا.
                    </li>
                  </ul>
                  <div className="p-3 mb-2 bg-info text-black ">
                    مثال: قد تساعد الزوايا الناعمة في تصحيح شكل الوجه المربع.
                  </div>
                  <hr />
                </div>
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      ما هي الفروق بين أشكال الوجه المختلفة؟
                    </h2>{" "}
                  </u>
                  <p>
                    تختلف أشكال الوجه في النسب بين عرض الجبهة، الخدين، والفك،
                    وكذلك الطول العام للوجه. يمكن لهذه الاختلافات أن تخلق مظهرًا
                    فريدًا لكل فرد.
                  </p>
                  <b>مثال</b>
                  <div className="p-3 mb-2 bg-info text-black ">
                    إذا كان لديك شكل وجه مثلث، فقد ترغب في تسليط الضوء على جوانب
                    أخرى من مظهرك لتوازن النسب.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default Example;
